import { Badge } from '@mantine/core'
import { useTranslation } from 'react-i18next'

const statuses = {
  loading: ['loading', 'gray'],
  rendering: ['rendering', 'pink'],
  ready: ['live', 'green'],
  error: ['error', 'red'],
}

export function PreviewStatus({ status }) {
  const { t } = useTranslation()
  const [labelKey, color] = statuses[status] || statuses.loading
  return <Badge size="xs" variant="light" color={color}>{t(`editorV2.shell.preview.status.${labelKey}`)}</Badge>
}
